/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{8C3D041E-BB12-4CC6-908A-4CF43E542E5B}",
  "sitecoreApiHost": "https://mattamyhomes.com",
  "jssAppName": "mattamy-homes",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/mattamy-homes",
  "graphQLEndpoint": "https://mattamyhomes.com/api/mattamy-homes?sc_apikey={8C3D041E-BB12-4CC6-908A-4CF43E542E5B}"
};